export const hasCentralSystemUrl = (value = "") => value.trim() !== "";

export const getChargePointWebSocketUrl = (centralSystemUrl = "", chargePointId = "") =>
  `${centralSystemUrl.trim().replace(/\/+$/, "")}/${chargePointId}`;
